import moment from "moment";
import { uniqueDomId } from "@/utils";
export const DATE_FORMAT = "YYYY-MM-DD";
export const TIME_FORMAT = "HH:mm:ss";
export const DATETIME_FORMAT = DATE_FORMAT + TIME_FORMAT;
export class Model {
    constructor(created, modified) {
        this.modifiedSince = false;
        this.saving = false;
        this.data = {
            created: moment(),
            modified: moment(),
        };
        this.cache = {};
        this.vueRef = uniqueDomId();
        if (created !== null && created !== undefined) {
            if (typeof created === "string") {
                this.data.created = moment(created);
            }
            else {
                this.data.created = created;
            }
        }
        if (modified !== null && modified !== undefined) {
            if (typeof modified === "string") {
                this.data.modified = moment(modified);
            }
            else {
                this.data.modified = modified;
            }
        }
    }
    modify() {
        this.modifiedSince = true;
        // this.data.modified = moment();
    }
    get created() {
        return this.data.created.clone();
    }
    get modified() {
        return this.data.modified.clone();
    }
    get isModified() {
        return this.modifiedSince;
    }
    get isSaving() {
        return this.saving;
    }
    save(options) {
        this.saving = true;
        this.update(options).then((res) => {
            if (res) {
                this.modifiedSince = false;
                this.saving = false;
            }
            else {
                throw new Error();
            }
        }).catch(() => {
            // TODO is this enough?
            this.saving = false;
        });
    }
    saveNew(options) {
        this.saving = true;
        return this.insert(options).then((res) => {
            this.modifiedSince = false;
            this.saving = false;
            return res;
        }).catch((err) => {
            // TODO
            this.saving = false;
            return Promise.reject(err);
        });
    }
}
//# sourceMappingURL=Model.js.map